import { QuestionPlanDiscountConnectionRoot as Root } from "@/components/features/items/edit/plan/_shared/ui/components/connection/discount-connection";

import { QuestionPlanDefaultDiscount } from "./default-discount-id";
import { QuestionPlanDiscountConnection } from "./discount-connection";
import { usePlanDiscountConnectionRoot } from "./hooks";

export const QuestionPlanDiscountConnectionRoot = () => {
	const { canShowDiscountConnection } = usePlanDiscountConnectionRoot();

	return (
		<Root>
			<QuestionPlanDefaultDiscount />
			{canShowDiscountConnection ? <QuestionPlanDiscountConnection /> : null}
		</Root>
	);
};

QuestionPlanDiscountConnectionRoot.displayName = "QuestionPlanDiscountConnectionRoot";
